import {DirectusTranslation} from './translation';

export enum ArchitecturalPrinciple {
  SUITE_WITHOUT_PAYROLL = 'suite',
  SUITE_WITH_PAYROLL = 'suite_with_payroll',
  STANDALONE_SYSTEM = 'standalone_system',
}

export const SUITE_PRINCIPLES: ReadonlySet<ArchitecturalPrinciple> = new Set([
  ArchitecturalPrinciple.SUITE_WITHOUT_PAYROLL,
  ArchitecturalPrinciple.SUITE_WITH_PAYROLL,
]);

export interface ArchitecturalPrincipleDirectus {
  id: string;
  sort_number: number | null;
  principles: ArchitecturalPrinciple[];
  translations: DirectusTranslation[];
}

export function parseArchitecturalPrinciple(
  value: string | undefined,
): ArchitecturalPrinciple | undefined {
  return Object.values(ArchitecturalPrinciple).find((principle) => principle === value);
}

export type SuitePrinciple =
  ArchitecturalPrinciple.SUITE_WITHOUT_PAYROLL | ArchitecturalPrinciple.SUITE_WITH_PAYROLL;

export function isSuitePrinciple(
  principle: ArchitecturalPrinciple | undefined,
): principle is SuitePrinciple {
  return principle !== undefined && SUITE_PRINCIPLES.has(principle);
}
